import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthComprasService } from 'src/app/service/auth-compras.service';

export const minhasComprasGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthComprasService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true; // Permite a navegação
  } else {
    // Se não estiver logado, redirecione para a tela de login
    router.navigateByUrl('/');
    return false; // Bloqueia a navegação
  }
};
